import React, { PureComponent } from 'react';

import Slider from 'components/slider/slider.component';

import {
  StyledWrapper,
} from "./hero.style";


class Hero extends PureComponent {

  render() {
    return (
      <StyledWrapper>
        <Slider/>
      </StyledWrapper>
    );
  }
}

export default Hero;


// WEBPACK FOOTER //
// ./src/components/hero/hero.component.js